<div *ngIf="!edit" class="media-body">
    <div class="media-heading">
        <div class="citation-title justify-content">
            <div class="flex-start">
                <h1 class="media-title">
                    {{asgmt.title}}
                    <rl-due-date *ngIf="asgmt.dueDate" [date]="asgmt.dueDate"></rl-due-date>
                </h1>
                <p *ngIf="asgmt.description">
                    <span class="ContentSummary">{{'asgmt.view.instructions' | translate}}:</span>
                    {{asgmt.description}}
                </p>
            </div>
            <div class="flex-end">
                <div *ngIf="submission?.grade" class="intro-messge-holder tada">
                    <div class="intro-messge">
                        <div class="intro-messge-inner">
                            <div class="justify-content ie-inline flex-wrap">
                                <div class="flex-half animationDelay text-right">
                                    <h2 class="title fadeInLeft">{{'asgmt.view.grade' | translate}}:</h2>
                                </div>
                                <div class="flex-half animationDelayMed text-left">
                                    <h3 class="title grade-title fadeInRight">&nbsp;{{submission.grade}}/{{asgmt.lmsAssignmentMaxScore}}</h3>
                                </div>
                            </div>
                            <!-- <div class="animationDelayMed">
                                <p class="no-margin fadeInRight">Course AVG: 98</p>
                            </div> -->
                        </div>
                        <div class="animationDelayMed" *ngIf="submission.feedback">
                            <p class="fadeInUp no-margin"><span class="semi-bold">{{'asgmt.view.feedback' | translate}}:</span> {{submission.feedback}}</p>
                        </div>
                    </div>
                </div>
                <div class="justify-content ie-inline flex-wrap">
                    <div *ngIf="!student" class="flex-basis">
                        <button (click)="edit=true" class="btn btn-link" [rlAria]="'lists.action.edit' | translate" [rTabIndex]>
                            <i class="fa fa-pencil"></i>
                            {{'lists.action.edit' | translate}}
                        </button>
                    </div>
                    <!-- <div class="flex-basis" *ngIf="!submission?.userSubmissionDate && dueDateHasPassed">
                        <p class="no-margin error-message semi-bold semi-large-text">
                            <i class="fa fa-exclamation-triangle"></i> {{'asgmt.view.submission.dueDateHasPassed' | translate}}
                        </p>
                    </div> -->
                    <div class="flex-basis" *ngIf="submission?.userSubmissionDate">
                        <div *ngIf="!submission?.grade">
                            <p class="no-margin ColorOrange semi-bold semi-large-text">
                                <i class="fa fa-calendar"></i> {{'asgmt.view.submission.submittedOn' | translate}}: 
                                <span class="oblique">{{submission.userSubmissionDate | customerDateTime}}</span>
                            </p>
                        </div>
                        <div *ngIf="submission?.grade">
                            <p class="no-margin label-success semi-bold semi-large-text">
                            <i class="fa fa-check"></i> {{'asgmt.view.submission.graded' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<rl-edit-form *ngIf="edit" [formType]="editFormType" [type]="'edit'" [item]="asgmt" (onClose)="edit=false" (onCancel)="edit=false"></rl-edit-form>
<p class="error-message" *ngIf="asgmt.sanitizeFile"><i class="fa fa-ban"></i> {{ (student ? 'asgmt.file.copyright.not.approved.msg.students' : 'asgmt.file.copyright.not.approved.msg.instructor') | translate}}</p>
<rl-embedded-view *ngIf="asgmtFile && (!asgmt.sanitizeFile || !student)" [file]="asgmtFile" [annotatorConfig]="annotator" [toolbarConfig]="{fullScreen : false}" class="pdfViewerDiv"></rl-embedded-view>
